module.exports = __webpack_public_path__ + "static/media/icon-user-management-color.05fce7b1.svg";